<template>
    <div class="block-editor b2cargo-order-status">
        <div class="b2cargo-order-status-info-wrapper">
            <div class="inputTitle">Query Type</div>
            <div class="text-editor-wrapper">
                <a-select class="classic-new-select" placeholder="Query Type" v-model="clone.type" :options="types" />
            </div>
        </div>
        <div class="b2cargo-order-status-info-wrapper">
            <div class="inputTitle">Company Code</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone._companyCode"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    placeholder="Company Code"
                    :rows="1"
                />
            </div>
        </div>
        <div class="b2cargo-order-status-info-wrapper" v-if="clone.type === 'billNo'">
            <div class="inputTitle">Bill No</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone._billNo"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    placeholder="Bill No"
                    :rows="1"
                />
            </div>
        </div>
        <div class="b2cargo-order-status-info-wrapper" v-if="clone.type === 'atf'">
            <div class="inputTitle">ATF Seri</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone._atfSeri"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    placeholder="ATF Seri"
                    :rows="1"
                />
            </div>
        </div>
        <div class="b2cargo-order-status-info-wrapper" v-if="clone.type === 'atf'">
            <div class="inputTitle">ATF No</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone._atfNo"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    placeholder="ATF No"
                    :rows="1"
                />
            </div>
        </div>
        <div class="b2cargo-order-status-info-wrapper" v-if="clone.type === 'systemNo'">
            <div class="inputTitle">System No</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone._systemNo"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    placeholder="System No"
                    :rows="1"
                />
            </div>
        </div>
        <div class="inputTitle mt-5 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
        <section class="next-step-filled-items-wrapper">
            <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                <AttributeIconPreview :attribute="attr" />
                <span class="ml-2">
                    <AttributeLabel :attribute="attr" />
                </span>
            </div>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import AttributeLabel from "../../common/tiptap-extensions/AttributeLabel";
import AttributeIconPreview from "../../common/AttributeIconPreview";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";

const log = log2("IdeasoftGetMemberInfo");
export default {
    name: "B2CargoLoginUser",
    components: { SupsisButton, TiptapEditor, AttributeLabel, AttributeIconPreview },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            types: [
                {
                    value: "systemNo",
                    label: "Sistem No",
                },
                {
                    value: "billNo",
                    label: "Fatura No",
                },
                {
                    value: "atf",
                    label: "ATF",
                },
            ],
            nextStepFilledValue: [
                "b2cargo_takipNo",
                "b2cargo_takipseri",
                "b2cargo_evrakdurum",
                "b2cargo_teslimtar",
                "b2cargo_gonderen",
                "b2cargo_aliciAdi",
                "b2cargo_cikisIl",
                "b2cargo_varisIl",
                "b2cargo_teslim",
                "b2cargo_urun",
                "b2cargo_atfTarih",
                "b2cargo_palet",
                "b2cargo_koli",
                "b2cargo_kg",
                "b2cargo_desi",
                "b2cargo_zimmetno",
                "b2cargo_varissube",
                "b2cargo_atfDurum",
            ],
        };
    },
    mounted() {
        log("mounted");
    },
    watch: {
        clone: {
            handler(val) {
                log("clone changed", val);
                this.$emit("input", val);
            },
            deep: true,
        },
        value(val) {
            if (_.isEqual(val, this.clone)) {
                return;
            }
            this.clone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.block-editor.b2cargo-order-status {
    padding: 30px 30px 0;

    .classic-new-select {
        width: 100%;
        font-weight: bold;

        [role="combobox"] {
            padding: 4px;
            border: none !important;
            border-radius: 4px !important;
            background-color: #f1f1f1 !important;
        }
    }

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: #fff;
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }

        .filled-attributes {
            margin: 0px 0px -17px -50px !important;
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        gap: 3px;
        flex-wrap: wrap;

        .middle-section {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;
        }
    }

    .active-connection-text {
        flex-grow: 1;
        flex-shrink: 0;
        width: 0;

        div {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: pre-wrap;
        }
    }

    .b2cargo-order-status-info-wrapper {
        margin-bottom: 15px;

        .inputTitle {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .editable-editor {
            p {
                margin-bottom: 0;
            }
        }
    }
}
</style>
